import React, { useEffect, useRef, useState } from "react";
import {
    Form,
    Dropdown,
    InputGroup
} from "react-bootstrap";
import { Funnel, XLg } from "react-bootstrap-icons";
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "./loader";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ROUTES, CATEGORIES_ID_NAME_MAP, BASE_URL } from "../assets/constant";
import { useDispatch, useSelector } from "react-redux";
import { globalSearch } from "../redux/authSlice";

const FilterOptions = ({ showToggle = true, hideOnLargeScreens }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth);
    const location = useLocation();
    const [selectedCategory, setSelectedCategory] = useState(
        user.globalSearch.category || null
    );
    const [show, setShow] = useState(false);
    const [showManufacturer, setShowManufacturer] = useState(false);
    const [manufacturerList, setManufacturerList] = useState([]);
    const [mfSearchValue, setMfSearchValue] = useState("");
    const [mfSelected, setMfSelected] = useState(
        user.globalSearch.manufacturer || []
    );
    const [recallDate, setRecallDate] = useState(
        user.globalSearch.recallDate ? new Date(user.globalSearch.recallDate) : null
    );
    const [noMoreMF, setNoMoreMF] = useState(false);

    const debounceTimeout = useRef(null);
    const mfPage = useRef(1);

    useEffect(() => {
        if (location.pathname === ROUTES.DASHBOARD) {
            setManufacturerList([]);
            setMfSearchValue("");
            setMfSelected([]);
            setRecallDate(null);
            setShow(false);
            setSelectedCategory(null);
            setShowManufacturer(false);
        }
        else if (location.pathname !== ROUTES.SEARCH) {
            setManufacturerList([]);
            setMfSearchValue("");
            setMfSelected([]);
            setRecallDate(null);
            setShow(false);
            setSelectedCategory(null);
            setShowManufacturer(false);
        }
    }, [location, dispatch]);

    const onCategoryChange = (category) => {
        setSelectedCategory(category);

        setShow(false);

        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            dispatch(globalSearch({ category: category }));
        }, 1000);
    };

    const toggleDropdown = () => setShow((prev) => !prev);

    const handleClearFilter = (e) => {
        e.preventDefault();
        setSelectedCategory(null);
        setShow(false);
        setManufacturerList([]);
        setMfSearchValue("");
        setMfSelected([]);
        setRecallDate(null);
        setShowManufacturer(false);
        dispatch(
            globalSearch({ category: null, manufacturer: [], recallDate: null })
        );
    };

    const getManufacturer = async () => {
        try {
            const response = await axios.post(
                `${BASE_URL}/v1/manufacturer-list`,
                {
                    page: mfPage.current,
                    searchQuery: mfSearchValue
                },
                {
                    headers: {
                        Authorization: `Bearer ${user.token}`
                    }
                }
            );
            setManufacturerList((prev) => [...prev, ...response.data.manufacturers]);
            setShowManufacturer(true);
            mfPage.current += 1;

            if (response.data.manufacturers.length === 0) {
                setNoMoreMF(true);
            }
        } catch (error) { }
    };

    const handleMfSearchChange = (e) => {
        setMfSearchValue(e.target.value);
    };

    const handleMFSearchKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            setManufacturerList([]);
            mfPage.current = 1;
            getManufacturer();
        }
    };

    const handleMfSelected = (manufacturer) => {
        const mfIncluded = mfSelected.includes(manufacturer);
        const updatedMfList = mfIncluded
            ? mfSelected.filter((mf) => mf !== manufacturer)
            : [...mfSelected, manufacturer];
        setMfSelected(updatedMfList);
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            dispatch(globalSearch({ manufacturer: updatedMfList }));
        }, 1000);
    };

    const sortedManufacturerList = [...manufacturerList].sort((a, b) => {
        const isASelected = mfSelected.includes(a);
        const isBSelected = mfSelected.includes(b);

        if (isASelected && !isBSelected) return -1; 
        if (!isASelected && isBSelected) return 1;  
        return 0; 
    });

    useEffect(() => {
        if (showManufacturer && mfSelected.length > 0) {
            setManufacturerList((prev) => {
                const uniqueManufacturers = new Set([...prev, ...mfSelected]);
                return Array.from(uniqueManufacturers);
            });
        }
    }, [showManufacturer, mfSelected]);

    // const handleRecallDateChange = (date) => {
    //     setRecallDate(date);

    //     clearTimeout(debounceTimeout.current);
    //     debounceTimeout.current = setTimeout(() => {
    //         dispatch(globalSearch({ recallDate: date }));
    //     }, 1000);
    // };

    return (
        <div className={hideOnLargeScreens ? "hide-on-large-screens" : ""}>
            <Dropdown show={show || !showToggle} onToggle={toggleDropdown} align="end">
                {showToggle && (
                    <Dropdown.Toggle
                        as={InputGroup.Text}
                        className="no-caret"
                        style={{
                            backgroundColor: "#d3d3d3",
                            border: "none",
                            borderRadius: "0 5px 5px 0",
                            cursor: "pointer",
                            fontSize: "12px",
                            height: "32px"
                        }}>
                        {show ? <XLg /> : <Funnel />}
                    </Dropdown.Toggle>
                )}

                {showManufacturer && (
                    <Dropdown.Menu
                        className="p-3 filter-dropdown"
                        onClick={(e) => e.stopPropagation()}>
                        <button
                            onClick={() => {
                                setShowManufacturer(false);
                                setManufacturerList([]);
                                mfPage.current = 1;
                                setNoMoreMF(false);
                                setMfSearchValue("");
                            }}
                            style={{
                                backgroundColor: "transparent",
                                border: "none",
                                fontSize: "14px",
                                cursor: "pointer"
                            }}>
                            <i className="fa fa-arrow-left"></i> Advanced Filter
                        </button>
                        <div className="d-flex justify-content-between align-items-center">
                            <Dropdown.Header>Select Manufacturer</Dropdown.Header>
                        </div>
                        <Form.Control
                            type="search"
                            style={{ fontSize: "14px", marginBottom: "10px" }}
                            placeholder="Search manufacturer"
                            aria-label="Search"
                            value={mfSearchValue}
                            onKeyPress={(e) => handleMFSearchKeyPress(e)}
                            onChange={handleMfSearchChange}
                        />
                        <InfiniteScroll
                            dataLength={manufacturerList.length}
                            next={getManufacturer}
                            hasMore={!noMoreMF}
                            loader={<Loader />}
                            height={200}>
                            {sortedManufacturerList.map((manufacturer) => (
                                <Form.Check
                                    key={manufacturer}
                                    type="checkbox"
                                    title={manufacturer}
                                    label={
                                        <span
                                            style={{
                                                display: "inline-block",
                                                width: "165px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}>
                                            {manufacturer}
                                        </span>
                                    }
                                    style={{ fontSize: "14px" }}
                                    checked={mfSelected.includes(manufacturer)}
                                    onChange={() => handleMfSelected(manufacturer)}
                                />
                            ))}
                        </InfiniteScroll>
                    </Dropdown.Menu>
                )}

                {!showManufacturer && (
                    <Dropdown.Menu className="p-3 w-100 filter-dropdown" >
                        <div className="d-flex justify-content-between align-items-center">
                            <Dropdown.Header>Select Category</Dropdown.Header>
                        </div>
                        {CATEGORIES_ID_NAME_MAP.map((category) => (
                            <Form.Check
                                key={category.id}
                                type="radio"
                                id={category.id}
                                name="categoryFilter"
                                label={
                                    <span
                                        style={{
                                            display: "inline-block",
                                            maxWidth: "150px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            color: selectedCategory === category.id ? "#5B68C3" : "inherit",
                                            fontWeight: selectedCategory === category.id ? "700" : "normal",
                                        }}>
                                        {category.name}
                                    </span>
                                }
                                className="custom-radio"
                                style={{ fontSize: "14px" }}
                                checked={selectedCategory === category.id}
                                onChange={() => onCategoryChange(category.id)}
                            />
                        ))}
                        <div className="border-top mt-2"></div>
                        <div className="d-flex justify-content-between align-items-center">
                            <Dropdown.Header>Search By</Dropdown.Header>
                        </div>
                        <Dropdown.Item
                            onClick={(e) => {
                                e.stopPropagation();
                                getManufacturer();
                            }}
                            style={{
                                textDecoration: "none",
                                backgroundColor: "transparent",
                                color: "black",
                                paddingTop: "0px",
                            }}
                            className="no-hover-focus">
                            <div
                                className="d-flex justify-content-between align-items-center"
                                style={{
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    color: "black",
                                    textDecoration: "none"
                                }}>
                                <span className="d-flex align-items-center">
                                    Manufacturer{" "}
                                    <span className="circular-chip">
                                        {mfSelected.length}
                                    </span>
                                </span>
                                <i className="fa fa-angle-right"></i>
                            </div>
                        </Dropdown.Item>
                        {/* <Dropdown.Item onClick={(e) => e.stopPropagation()}>
                            <ReactDatePicker
                                onChange={(date) => handleRecallDateChange(date)}
                                selected={recallDate}
                                className="form-control form-control-sm"
                                placeholderText="Select Recall Date"
                                maxDate={new Date()}
                                dateFormat="yyyy-MM-dd"
                            />
                        </Dropdown.Item> */}
                        <div className="mt-2 border-top pt-2 text-center">
                            <button
                                className="text-primary cursor-pointer"
                                style={{
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    border: "none",
                                    backgroundColor: "transparent"
                                }}
                                onClick={handleClearFilter} // Reset category
                            >
                                Clear Filter
                            </button>
                        </div>
                    </Dropdown.Menu>
                )}
            </Dropdown>
        </div>

    )
}

export default FilterOptions